<template>
	 <v-container>
		 <!-- 新生缴费 选择课程进行缴费 -->
		 <v-dialog title="学员缴费" v-model="hideShow" width="600px" min-height="300" persistent>
			<v-card>
				<v-card-title>
					<span>学员缴费</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense v-if="student">
						<v-col cols="6">
							<v-text-field label="学员姓名" v-model="student.studentName" disabled dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="学员学号" v-model="student.studentNo" disabled dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="12" class="mt-n3">
							<v-select v-model="add.courseModel" :items="selectCourseList" label="请选择缴费课程" item-text="courseName"
								item-value="id" return-object outlined dense @change="courseChanged"></v-select>
						</v-col>
						<v-col cols="12" class="mt-n3 d-flex">
							<v-select v-model="add.priceModel" :disabled="!add.courseModel" :items="coursePriceList" label="请选择价格套餐" item-text="viewText"
								item-value="id" return-object clearable outlined dense @change="priceChanged" no-data-text="暂无价格套餐数据"></v-select>
						</v-col>
						<v-col cols="6" class="mt-n3">
							<v-select :items="selectTeacherList" v-model="add.order.salesTeacherId" item-text="trueName"
								item-value="id" label="开单老师" dense outlined clearable></v-select>
						</v-col>
						<v-col cols="6" class="mt-n3">
							<v-select :items="selectTeacherList" v-model="add.order.classTeacherId" item-text="trueName"
								item-value="id" label="上课老师" dense outlined clearable></v-select>
						</v-col>
					</v-row>
					
					<!-- 现金学费的课程缴费 -->
					<v-row dense v-if="add.courseModel&&add.courseModel.consumeType=='2'">
						<v-col cols="12" class="mt-n4 mb-1">
							<span>该课程为</span>
							<span style="color:red;font-weight: 500;">"按金额扣费"</span>
							<span>方式，即每次上课扣除金额账户的余额</span>
						</v-col>
						
						<v-col cols="6">
							<v-text-field label="缴费金额"  v-model="add.order.cashAmount" type="number" dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="赠送金额" v-model="add.order.giveAmount" type="number" dense outlined>
							</v-text-field>
						</v-col>
						
						<v-col cols="6" class="mt-n5">
							<v-select label="请选择优惠券" v-model="add.selectedCoupon" 
							:items="studentCouponItems" item-text="couponName" item-value="id" 
							no-data-text="没有可用优惠券"
							return-object clearable :disabled="!add.order.cashAmount"
							dense outlined @change="cashCouponChanged"></v-select>
						</v-col>
						<v-col cols="6" class="mt-n5">
							<v-text-field label="优惠券金额" v-model="couponAmount" disabled dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="6" class="mt-n5">
							<v-text-field label="增加总金额" v-model="totalTuitionFee" disabled dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="6" class="mt-n5">
							
							<span class="mt-2">需付款金额:</span>
							<span class="text-h6 ml-2 mt-1" style="color:red">{{cashRealPayFee}}</span>
							<span class="mt-2 ml-1">元</span>
						</v-col>
						<v-col cols="4" class="mt-n5">
							<v-select v-model="add.order.payType" :items="payTypeList" label="付款方式" item-text="text"
								item-value="code" clearable outlined dense no-data-text="暂无付款方式"></v-select>
						</v-col>
						<v-col cols="8" class="mt-n5">
							<v-text-field label="备注" v-model="add.order.memo" dense outlined>
							</v-text-field>
						</v-col>
					</v-row>
					
					<!-- 课时的课程缴费 -->
					<v-row dense v-if="add.courseModel&&add.courseModel.consumeType=='1'">
						<v-col cols="12" class="mt-n5">
							<span>该课程为</span>
							<span style="color:red;font-weight: 500;">"按课时扣费"</span>
							<span>方式，即每次上课扣除该课程的课时数</span>
						</v-col>
						<v-col cols="6">
							<v-text-field label="课程原价"  v-model="add.order.courseAmount" type="number" dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="增加课时"  v-model="add.order.classHours" type="number" dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="6" class="mt-n5">
							<v-select label="请选择优惠券" v-model="add.selectedCoupon" 
							:items="studentCouponItems" item-text="couponName" item-value="id" 
							no-data-text="没有可用优惠券"
							return-object clearable :disabled="!add.order.courseAmount"
							dense outlined @change="courseCouponChanged"></v-select>
						</v-col>
						<v-col cols="6" class="mt-n5">
							<v-text-field label="优惠券金额" v-model="couponAmount" disabled dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="6" class="mt-n5">
							<v-text-field label="减免金额"  v-model="add.order.reduceAmount" type="number" dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="6" class="mt-n5">
							<span class="mt-2">需付款金额:</span>
							<span class="text-h6 ml-2 mt-1" style="color:red">{{courseRealPayFee}}</span>
							<span class="mt-2 ml-1">元</span>
						</v-col>
						<v-col cols="4" class="mt-n5">
							<v-select v-model="add.order.payType" :items="payTypeList" label="付款方式" item-text="text"
								item-value="code" clearable outlined dense no-data-text="暂无付款方式"></v-select>
						</v-col>
						<v-col cols="8" class="mt-n5">
							<v-text-field label="备注" v-model="add.order.memo" dense outlined>
							</v-text-field>
						</v-col>
					</v-row>
					
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitOrder" :loading="add.submitLoadding" color="info">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	import utils from "../config/utils.js"
	export default {
		name:"student-recharge",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			student:{
				type:Object,
				default:null
			},
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					// 显示组件时
					this.clearAdd();
					
					// 加载课程
					this.getCourseListForSelect();
					// 加载优惠券
					this.getStudentCouponListForSelect();
				}
			}
		},
		computed:{
			cashRealPayFee(){
				if(!this.add.order.cashAmount){
					return "0";
				}
				
				let orderAmount = parseFloat(this.add.order.cashAmount);
				let couponAmount = 0;
				if (this.add.selectedCoupon){
					couponAmount = parseFloat(this.add.selectedCoupon.amount);
				}
		
				let result = orderAmount - couponAmount;
		
				return result > 0 ? result:0 ;
			},
			courseRealPayFee(){
				if(!this.add.order.courseAmount){
					return "0";
				}
				
				let orderAmount = parseFloat(this.add.order.courseAmount);
				let couponAmount = 0;
				// 优惠券减
				if (this.add.selectedCoupon){
					couponAmount = parseFloat(this.add.selectedCoupon.amount);
				}
				// 直减
				let reduceAmount = 0
				if (this.add.order.reduceAmount){
					reduceAmount = parseFloat(this.add.order.reduceAmount);
				}
				
				let result = orderAmount - couponAmount - reduceAmount;
			
				return result > 0 ? result:0 ;
			},
			totalTuitionFee(){
				let cashAmount = 0;
				if(this.add.order.cashAmount){
					cashAmount = parseFloat(this.add.order.cashAmount);
				}
				let giveAmount = 0;
				if(this.add.order.giveAmount){
					giveAmount = parseFloat(this.add.order.giveAmount);
				}
				
				let result =  cashAmount + giveAmount;
				
				return result.toString();
			},
			couponAmount(){
				if(!this.add.selectedCoupon){
					return "0";
				}
				
				return this.add.selectedCoupon.amount;
			},
			courseDisabled(){
				let result = false;
				if (this.add.priceModel){
					if(this.add.priceModel.consumeType =="1"){
						result = true;
					}
				}
				
				return result;
			},
			cashDisabled(){
				let result = false;
				if (this.add.priceModel){
					if(this.add.priceModel.consumeType =="2"){
						result = true;
					}
				}
				
				return result;
			}
		},
		data(){
			return {
				add: {
					submitLoadding:false,
					courseModel:null,
					selectedCoupon:null,
					priceModel:null,
					order: {
						cashAmount:"",
						giveAmount:"",
						courseAmount:"",
						classHours:"",
						reduceAmount:"",
						memo:"",
						payType:"",
						salesTeacherId:"",
						classTeacherId:""
					},
				},
				shopId:"",
				selectTeacherList: [], //选择老师数据源
				selectCourseList:[],// 课程数据源
				studentCouponItems:[], //优惠券数据源
				hideShow:this.show,
				coursePriceList:[], //课程价格套餐
				payTypeList:[
					{code:'ALIPAY',text:'支付宝'},
					{code:'WXPAY',text:'微信'},
					{code:'CASH',text:'现金'},
				],
			}
		},
		mounted() {
			console.log("student-recharge mounted");
			
			this.shopId = utils.getCurrentShopId(); 
			
			this.getTeacherListForSelect();
		},
		methods:{
			clearAdd(){
				this.add.courseModel = null;
				this.add.order.cashAmount = "";
				this.add.order.giveAmount = "";
				this.add.order.courseAmount = "";
				this.add.order.classHours = "";
				this.add.order.memo = "";
				this.add.selectedCoupon = null;
				this.add.order.reduceAmount = "";
				this.add.order.payType = "";
				this.add.order.salesTeacherId = "";
				this.add.order.classTeacherId = "";
				
				// 课程价格
				this.coursePriceList = [];
			},
			cancel(){
				this.$emit("cancel","");
			},
			courseChanged(e){
				// 选择的课程变了 
				console.log(e);
				
				this.add.priceModel = null; // 未选中价格对象
				this.coursePriceList = [];  // 套餐列表清空
				
				this.add.order.courseAmount = "";
				this.add.order.classHours = "";
				this.add.order.reduceAmount = "";
				this.add.order.cashAmount = "";
				this.add.order.giveAmount = "";
				// 获取课程价格模板
				this.getCoursePriceListForSelect();
			},
			priceChanged(e){
				// 选择了套餐价格
				console.log(e);
				if (e){
					if (e.consumeType == '1'){
						this.add.order.courseAmount = e.courseAmount;
						this.add.order.classHours = e.addHours;
						this.add.order.reduceAmount = e.reduceAmount;
					}else if(e.consumeType == '2'){
						this.add.order.cashAmount = e.courseAmount;
						this.add.order.giveAmount = e.giveAmount;
					}
					
				}else{
					this.add.order.courseAmount = "";
					this.add.order.classHours = "";
					this.add.order.reduceAmount = "";
					this.add.order.cashAmount = "";
					this.add.order.giveAmount = "";
				}
			},
			cashCouponChanged(e){
				console.log(e);
				// 学费 优惠券选择
				let limitAmount = parseFloat(e.limitAmount);
				const cashAmount = parseFloat(this.add.order.cashAmount);
				if (limitAmount > 0){
					// 有金额限制 判断金额限制
					if (cashAmount < limitAmount){
						// 不符合
						
						this.$noty.error('优惠券需满'+limitAmount+'元才能使用');
						const that = this;
						setTimeout(()=>{
							that.add.selectedCoupon = null;
						},100)
					}
				}
				
			},
			courseCouponChanged(e){

				// 课时 优惠券选择
				let limitAmount = parseFloat(e.limitAmount);
				const cashAmount = parseFloat(this.add.order.courseAmount);
				if (limitAmount > 0){
					// 有金额限制 判断金额限制
					if (cashAmount < limitAmount){
						// 不符合
						
						this.$noty.error('优惠券需满'+limitAmount+'元才能使用');
						const that = this;
						setTimeout(()=>{
							that.add.selectedCoupon = null;
						},100)
					}
				}
				
			},
			submitOrder(){
				
				if(!this.add.courseModel || !this.add.courseModel.id){
					this.$noty.error('请选择课程');
					return;
				}
				const consumeType = this.add.courseModel.consumeType;
				if (consumeType == '1'){
					if(!this.add.order.courseAmount){
						this.$noty.error('请输入缴费金额');
						return;
					}
					
					// 判断正2位小数金额
					const isFloat = utils.isDecimal(this.add.order.courseAmount);
					if (!isFloat){
						this.$noty.error('请输入最多2位小数的金额');
						return;
					}
					
					if(!this.add.order.classHours){
						this.$noty.error('请输入课时数');
						return;
					}
					
					if(!utils.isInt(this.add.order.classHours)){
						this.$noty.error('课时只能输入正整数');
						return;
					}
					
				}else if (consumeType == '2'){
					if(!this.add.order.cashAmount){
						this.$noty.error('请输入缴费金额');
						return;
					}
					const isFloat = utils.isDecimal(this.add.order.cashAmount);
				
					if (!isFloat){
						this.$noty.error('请输入最多2位小数的金额');
						return;
					}
				}
				this.add.submitLoadding = true;
				let postData = {
					studentId:this.student.id,
					courseId:this.add.courseModel.id,
					consumeType:consumeType,
					cashAmount:this.add.order.cashAmount,
					giveAmount:this.add.order.giveAmount,
					courseAmount:this.add.order.courseAmount,
					classHours:this.add.order.classHours,
					reduceAmount:this.add.order.reduceAmount,
					memo:this.add.order.memo,
					payType:this.add.order.payType,
					salesTeacherId:this.add.order.salesTeacherId,
					classTeacherId:this.add.order.classTeacherId
					
				}
				if(this.add.selectedCoupon){
					postData.studentCouponId = this.add.selectedCoupon.id;
				}
				if (this.add.priceModel){
					postData.priceId = this.add.priceModel.id;
				}
				
				// api
				const that = this;
				let url = `/financial/student/recharge`;
				
				this.axios.post(url, postData).catch(() => {
					that.add.submitLoadding = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.add.submitLoadding = false;
							that.$noty.success("添加成功");
							
							// 提交成功
							that.$emit("success","");
							
							return;
						} else {
							that.add.submitLoadding = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.submitLoadding = false;
						that.$noty.error('网络请求失败');
					}
				
				});
				
				
				
			},
			getCourseListForSelect() {
			
				const shopId = this.student.shopId;
				
				if (!shopId) {
					return
				}
			
				const that = this;
				let url = `/edu/shop/course/list/` + shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						
						let cList = response.data["data"] ? response.data["data"] : [];
						
						console.log(cList);
						
			
						that.selectCourseList = cList.filter(item => item.status === '1')
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getStudentCouponListForSelect() {
				// 获取学生优惠券
				const studentId = this.student.id;
				if (!studentId) {
					return
				}
				const that = this;
				let url = `/financial/student/all/coupon/list/` + studentId;
			
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						console.log(">>>>>>>>>获取学员优惠券 start>>>>>>>>>")
						
						console.log("url:",url);
						console.log("res:",response.data);
						
						console.log(">>>>>>>>>获取学员优惠券 end>>>>>>>>>")
						
						that.studentCouponItems = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getCoursePriceListForSelect() {
				
				// 获取课程价格套餐
				
				const courseId = this.add.courseModel.id;
				
				if (!courseId) {
					return
				}
				
				const that = this;
				let url = `/financial/course/${courseId}/available/price/list`;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.coursePriceList = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getTeacherListForSelect() {
			
				if (!this.shopId) {
					return
				}
			
				const that = this;
				let url = `/edu/shop/teacher/list/` + this.shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.selectTeacherList = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		}
	}
	
</script>

<style>
</style>
